/**
 * Remembers the last workspace the user was looking at, so /app can
 * route them straight back to it across reloads.
 */

const KEY = "sm.app.lastWorkspaceId";

export function getLastWorkspaceId(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastWorkspaceId(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    // non-fatal — navigation still works without the hint
  }
}

/**
 * Remembers the last brand the user viewed within a given workspace, so
 * workspace-level pages (Members, Settings) can keep the brand-scoped nav
 * anchored to it instead of collapsing. Keyed per workspace — different
 * workspaces own different brands.
 */
const BRAND_KEY_PREFIX = "sm.app.lastBrandId.";

export function getLastBrandId(wsId: string): string | null {
  try {
    return window.localStorage.getItem(BRAND_KEY_PREFIX + wsId);
  } catch {
    return null;
  }
}

export function setLastBrandId(wsId: string, brandId: string): void {
  try {
    window.localStorage.setItem(BRAND_KEY_PREFIX + wsId, brandId);
  } catch {
    // non-fatal — nav falls back to the first brand without the hint
  }
}
